import { field, date, relation,text, json } from '@nozbe/watermelondb/decorators';
import { GROUP_PAYMENT_LEDGER_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';
import { sanitizeImages } from '../../constants';

export default class GroupPaymentLedger extends Model {
    static table = GROUP_PAYMENT_LEDGER_SCHEMA;

    static associations = {
        group_payments: { type: 'belongs_to', key: 'group_payment_id' },
        customer: { type: 'belongs_to', key: 'customer_id' },
        business: { type: 'belongs_to', key: 'business_id' },
        groups: { type: 'belongs_to', key: 'group_id' },
    }

    @text('payment_mode') payment_mode;
    @text('image_url') image_url;
    @text('recording') recording;
    @field('amount') amount;
    @text('method') method;
    @text('wallet') wallet;
    @text('note') note;
    @text('type') type;
    @text('bank') bank;
    @json('attachment', sanitizeImages) attachment;

    @date('transacted_at') transacted_at;
    @date('created_at') created_at;

    @relation('group_payments', 'group_payment_id') group_payments;
    @relation('customer', 'customer_id') customer;
    @relation('business', 'business_id') business;
    @relation('groups', 'group_id') groups;
};